import {
  Box,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { NoDataContainer, StyledTableCell } from "../../Common/styles/table";
import { DashboardCardStyle } from "../DashboardContent/style";

const GroupRecruitmentTable = ({ data, handleOptionsClick }: any) => {
  return (
    <Box sx={DashboardCardStyle}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          color="text.primary"
        >
          Group Recruitment
        </Typography>
      </Box>
      <Box>
        {!data?.data || data?.data?.length === 0 ? (
          <NoDataContainer>
            <Typography variant="body1" color="gray">
              No data
            </Typography>
          </NoDataContainer>
        ) : (
          <Box
            sx={{
              maxHeight: "calc(100vh - 295px)",
              overflow: "auto",
              mb: 2,
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Group Name</StyledTableCell>
                  <StyledTableCell>Target</StyledTableCell>
                  <StyledTableCell>Enrolled</StyledTableCell>
                  <StyledTableCell>Consented</StyledTableCell>
                  <StyledTableCell>Scheduled</StyledTableCell>
                  <StyledTableCell>Completed</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data?.data?.map((row: any, index: number) => (
                  <TableRow key={index}>
                    <StyledTableCell>{row?.label}</StyledTableCell>
                    <StyledTableCell>{row?.targetCount}</StyledTableCell>
                    <StyledTableCell>{row?.count}</StyledTableCell>
                    <StyledTableCell>
                      {row?.consentedParticipants}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row?.scheduledAppointments}
                    </StyledTableCell>
                    <StyledTableCell>
                      {row?.completedAppointments}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GroupRecruitmentTable;
